"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["message"],
  methods: {
    getFormattedDate: function getFormattedDate(date) {
      return Fn.getFormattedDate(date);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/EmailSMSBlock.vue
// module id = VxTr
// module chunks = 0 1